import { render, staticRenderFns } from "./PlanningTabs.vue?vue&type=template&id=70593876&lang=pug&"
import script from "./PlanningTabs.vue?vue&type=script&lang=js&"
export * from "./PlanningTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports